export const FETCH_ACTIVE_INTERNAL_BANNER_RESOLVED = "FETCH_ACTIVE_INTERNAL_BANNER_RESOLVED";